import React, { useState } from 'react';
import { useHistory } from 'react-router';
import ContentItemTestCasesPanel from '../simulator/components/ContentItemTestCasesPanel';
import TestCase from '../../models/customAssistant/TestCase';
import styled from '@emotion/styled';
import TestCaseHistoryViewer from '../../components/forms/TestCaseHistoryViewer';
import TestCaseContainer from '../../hooks/TestCaseContainer';
import ApplicationModel from '../../models/applications/api/ApplicationModel';
import SimulatorContainer from '../../hooks/SimulatorContainer';

interface TestCaseViewerProps {
    application: ApplicationModel,
    contentItemId: string
    getResponseId: (responseId: string) => void,
    responseIdToNamesRef: { current: Record<string, string> }
}

const ContentItemTestCaseViewer: React.FC<TestCaseViewerProps> = ({
    application,
    contentItemId,
    getResponseId,
    responseIdToNamesRef }) => {
    const [runningTestCase, setRunningTestCase] = useState(null);
    const testCaseContainer = TestCaseContainer.useContainer();
    const history = useHistory()

    const runTestCase = async (testCase: TestCase) => {
        try {
            setRunningTestCase(testCase)
            const response = await testCaseContainer.simulateTestCase(testCase)
            getResponseId(response.responseId)
            return response
        }
        catch (error) {
            console.log(error)
        }
    }

    const simulateTestCase = async (testCase: TestCase) => {
        sessionStorage.setItem("testCaseToSimulate", JSON.stringify(testCase))
        history.push(`/v/apps/${application.id}/simulator`)
    }

    return (
        <div>
            <StyledContainer>
                <ContentItemTestCasesPanel
                    application={application}
                    contentItemId={contentItemId}
                    runTestCase={runTestCase}
                    simulateTestCase={simulateTestCase}
                    responseIdToNamesRef={responseIdToNamesRef}
                />
            </StyledContainer>
            {runningTestCase != null && (
                <StyledContainer>
                    <StyledLabel>Current Test Case: {runningTestCase.name}</StyledLabel>
                    <TestCaseHistoryViewer currentTestCase={runningTestCase} />
                </StyledContainer>
            )}
        </div>
    )
}

const StyledContainer = styled.div`
    padding: 16px;
    width: 100%;
    display: block;
    justify-content: flex-start;
`;

const StyledLabel = styled.h3`
`

export default ContentItemTestCaseViewer